import { render } from "./AdsPackageCreating.vue?vue&type=template&id=29b9252e&ts=true"
import script from "./AdsPackageCreating.vue?vue&type=script&lang=ts"
export * from "./AdsPackageCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__